import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import * as uuid from 'uuid';

export type Role = 'info' | 'success' | 'warning' | 'error';

export interface Message {
    content: string;
    role: string;
    timestamp: number;
    id: string;
}

@Injectable({
    providedIn: 'root'
})
export class MessagesService {
    private _messages: Message[] = [];

    constructor() { }

    public get messages() {
        return this._messages;
    }

    public added = new EventEmitter<Message>();
    public removed = new EventEmitter<Message>();

    public addOne(message: unknown, role: Role) {
        const id = uuid.v4();
        const msg = {
            content: message,
            role: role,
            timestamp: Date.now(),
            id,
        } as Message;
        this._messages.push(msg);

        if (msg.role === 'error') console.error('ERROR:', msg.content);
        // else console.log(msg.role, msg.content);

        const timeout = setTimeout(() => {
            this.removed.next(this._messages.find(v => v.id === id)!);
            this._messages = this._messages.filter(v => v.id !== id);
            clearTimeout(timeout);
        }, 2500);

        this.added.next(msg);
    }
    public add(message: unknown, role: Role) {
        this.errors(message, val => this.addOne(val, role));
    }

    public error = (message: unknown) => this.add(message, 'error');
    public warn = (message: unknown) => this.add(message, 'warning');
    public success = (message: unknown) => this.add(message, 'success');
    public info = (message: unknown) => this.add(message, 'info');

    public errors(error: any, res: (val: string) => void): void {
        if (error === undefined || error === null) return;
        if (typeof error === 'string') return res(error);
        if (error instanceof Array) {
            for (var i = 0; i < error.length; i++) {
                this.errors(error[i], res);
            }
            return;
        }
        if (typeof error === 'object') {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 501) return res(`This functionality is not yet supported`);
                else if (error.status >= 500 && error.status < 600) return res(`Server error (code ${error.status})`);
                else if (error.status >= 400 && error.status < 500) {
                    if (error.error != null) return this.errors(error.error, res);
                    else return res(`Error ${error.status}`);
                }
            }
            if ('errors' in error) return this.errors(error.errors, res);
            if ('map' in error) return this.errors(error.map, res);
            if (error instanceof Error) return res(error.message);

            if ('content' in error) {
                if ('field' in error) return res(error.field + ": " + error.content);
                else return res(error.content);
            }
        }
        res("Unknown error (the server is probably down)");
    }
}
